// Image
const sizes = {
  '2xs': { size: 6 },
  'xs': { size: 10 },
  'sm': { size: 16 },
  'md': { size: 20 },
  'lg': { size: 24 },
  'xl': { size: 32 },
  '2xl': { size: 64 },
  'full': { size: '100%' },
};

export const Image = {
  baseStyle: {
    maxWidth: '100%',
  },
  sizes,
  defaultProps: {},
};
